export const isInFullScreen = (state) => state.player.state.isInFullScreen;
export const isPlayerUIVisible = (state) => state.player.ui.isVisible;
export const isMuted = (state) => state.player.state.muted;
export const isVolumeChangedByUser = (state) =>
  state.player.state.isVolumeChangedByUser;
export const isAutoplayed = (state) => state.player.state.autoPlayed; // TODO fix for lightbox
export const getOverlayContent = (state) => state.player.state.overlayContent;
